export default __webpack_public_path__ + "static/media/noexpl_08_EN.f6d7c58d.png";